export const barChartBundle = {
  usage: { ko: "사용량", en: "Usage", es: "Uso" }
}

export const PAGE_SIZE = 10
